
import apiConfig from '@/config/api.config'
import ImageUploader from '@/components/common/ImageUploader.vue'

export default {
  name: 'PromotionManage',
  components: {
    ImageUploader
  },
  data () {
    return {
      promotions: [],
      products: [],
      gifts: [],
      showAddModal: false,
      editingPromotion: null,
      productSearch: '',
      searchedProducts: [], // 选品服务端搜索结果（productSearch 非空时；2026-09-18 统一整改）
      showPreview: false,
      sectionErrors: [],
      promoForm: {
        name: '',
        banner_image: '',
        start_date: '',
        end_date: '',
        status: 'active',
        gift_rule: '',
        gift_sections: [{ buy_qty: 5, gift_qty: 1 }], // 多档规则数组
        gift_product_id: '',
        gift_id: '',
        productIds: []
      }
    }
  },
  computed: {
    availableProducts () {
      return this.products.filter(p => !this.promoForm.productIds.includes(p.id))
    },
    filteredAvailableProducts () {
      // 2026-09-18 搜索统一整改：选品搜索走服务端（/admin/gift-products?keyword=，与正式
      // 搜索同一核心——拼音/首字母/助记码/编码/同义词全量召回），不再本地 name includes 过滤。
      if (!this.productSearch) return this.availableProducts.slice(0, 20)
      return this.searchedProducts.filter(p => !this.promoForm.productIds.includes(p.id)).slice(0, 50)
    },
    // 规则预览数据
    previewData () {
      if (!this.promoForm.gift_rule || this.promoForm.gift_sections.length === 0) {
        return []
      }
      // 使用 GiftRuleEngine 计算预览
      const { GiftRuleEngine } = require('@/utils/GiftRuleEngine')
      const engine = new GiftRuleEngine(this.promoForm.gift_sections)
      return engine.generatePreview(20) // 预览前 20 个数量
    }
  },
  watch: {
    // 选品搜索：300ms 防抖打服务端（与正式搜索同一核心）；空串清结果回全量候选
    productSearch (v) {
      clearTimeout(this._productSearchTimer)
      const kw = String(v || '').trim()
      if (!kw) { this.searchedProducts = []; return }
      this._productSearchTimer = setTimeout(() => this.searchProductsServer(kw), 300)
    }
  },
  created () {
    this.fetchPromotions()
    this.fetchProducts()
    this.fetchGifts()
  },
  methods: {
    // 选品服务端搜索（2026-09-18 统一整改：/admin/gift-products?keyword= 收口到搜索核心）
    async searchProductsServer (kw) {
      try {
        const res = await this.axios.get('/admin/gift-products', { params: { keyword: kw } })
        if (res.data.code === 200) this.searchedProducts = res.data.data || []
      } catch (e) {
        console.error('搜索商品失败:', e)
      }
    },
    async fetchPromotions () {
      try {
        const token = localStorage.getItem('token')
        const res = await this.axios.get(`/admin/promotions`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        if (res.data.code === 200) {
          this.promotions = res.data.data
        }
      } catch (err) {
        console.error('获取活动列表失败:', err)
      }
    },
    async fetchProducts () {
      try {
        const token = localStorage.getItem('token')
        const res = await this.axios.get(`/admin/gift-products`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        if (res.data.code === 200) {
          this.products = res.data.data
        }
      } catch (err) {
        console.error('获取商品列表失败:', err)
      }
    },
    async fetchGifts () {
      try {
        const token = localStorage.getItem('token')
        const res = await this.axios.get(`/admin/gifts`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        if (res.data.code === 200) {
          this.gifts = res.data.data
        }
      } catch (err) {
        console.error('获取赠品列表失败:', err)
      }
    },
    async fetchPromotionProducts (promotionId) {
      try {
        const token = localStorage.getItem('token')
        const res = await this.axios.get(`/admin/promotions/${promotionId}/products`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        if (res.data.code === 200) {
          return res.data.data.map(p => p.product_id)
        }
      } catch (err) {
        console.error('获取活动商品失败:', err)
      }
      return []
    },
    getProductName (productId) {
      const product = this.products.find(p => p.id === productId)
      return product ? product.name : productId
    },
    addProduct (productId) {
      if (productId && !this.promoForm.productIds.includes(productId)) {
        this.promoForm.productIds.push(productId)
      }
    },
    removeProduct (productId) {
      this.promoForm.productIds = this.promoForm.productIds.filter(id => id !== productId)
    },
    // 多档规则管理
    addGiftSection () {
      const lastSection = this.promoForm.gift_sections[this.promoForm.gift_sections.length - 1]
      const newBuyQty = lastSection ? lastSection.buy_qty * 2 : 10
      const newGiftQty = lastSection ? Math.floor(newBuyQty / 2) : 1
      this.promoForm.gift_sections.push({
        buy_qty: newBuyQty,
        gift_qty: newGiftQty
      })
      this.validateSections()
    },
    removeGiftSection (index) {
      if (this.promoForm.gift_sections.length > 1) {
        this.promoForm.gift_sections.splice(index, 1)
        this.validateSections()
      }
    },
    validateSections () {
      this.sectionErrors = []
      const sections = this.promoForm.gift_sections

      // 检查每档的有效性
      sections.forEach((section, idx) => {
        if (section.buy_qty <= 0) {
          this.sectionErrors.push(`档位 ${idx + 1}: 购买数量必须大于0`)
        }
        if (section.gift_qty < 0) {
          this.sectionErrors.push(`档位 ${idx + 1}: 赠品数量不能为负数`)
        }
        if (section.buy_qty <= section.gift_qty) {
          this.sectionErrors.push(`档位 ${idx + 1}: 购买数量(${section.buy_qty})建议大于赠品数量(${section.gift_qty})`)
        }
      })

      // 检查是否按 buy_qty 递增
      for (let i = 1; i < sections.length; i++) {
        if (sections[i].buy_qty <= sections[i - 1].buy_qty) {
          this.sectionErrors.push(`档位 ${i + 1}: 购买数量(${sections[i].buy_qty})应大于前一档(${sections[i - 1].buy_qty})`)
        }
      }
    },
    togglePreview () {
      this.showPreview = !this.showPreview
    },
    async editPromotion (promo) {
      this.editingPromotion = promo
      // 获取关联的商品
      const productIds = await this.fetchPromotionProducts(promo.id)

      // 解析 gift_rules / gift_sections（兼容新旧格式）
      let giftSections = [{ buy_qty: 5, gift_qty: 1 }]

      // 优先使用新的 gift_rules 结构
      if (promo.gift_rules && Array.isArray(promo.gift_rules) && promo.gift_rules.length > 0) {
        giftSections = promo.gift_rules
      } else if (promo.gift_sections && Array.isArray(promo.gift_sections) && promo.gift_sections.length > 0) {
        giftSections = promo.gift_sections
      } else if (promo.buy_quantity && promo.gift_quantity) {
        // 兼容旧格式
        giftSections = [{ buy_qty: promo.buy_quantity, gift_qty: promo.gift_quantity }]
      }

      this.promoForm = {
        name: promo.name,
        banner_image: promo.banner_image || '',
        start_date: promo.start_date || '',
        end_date: promo.end_date || '',
        status: promo.status || 'active',
        gift_rule: promo.promotion_type || promo.gift_rule || '',
        gift_sections: giftSections,
        gift_product_id: promo.gift_product_id || '',
        gift_id: promo.gift_id || '',
        productIds: productIds
      }
      this.showPreview = false
      this.sectionErrors = []
    },
    async savePromotion () {
      // 验证多档规则
      this.validateSections()
      if (this.sectionErrors.length > 0 && this.promoForm.gift_rule) {
        alert('请修正规则错误后再保存')
        return
      }

      try {
        const token = localStorage.getItem('token')
        // 使用新的统一数据结构
        const data = {
          name: this.promoForm.name,
          bannerImage: this.promoForm.banner_image,
          startDate: this.promoForm.start_date,
          endDate: this.promoForm.end_date,
          status: this.promoForm.status,
          // 新统一格式
          promotionType: this.promoForm.gift_rule || 'gift',
          giftCalcMode: 'min_gift_combination',
          giftRules: this.promoForm.gift_rule ? this.promoForm.gift_sections : [],
          // 兼容旧字段
          giftProductId: this.promoForm.gift_product_id || null,
          giftId: this.promoForm.gift_id || null,
          productIds: this.promoForm.productIds
        }
        if (this.editingPromotion) {
          await this.axios.put(
            `/admin/promotions/${this.editingPromotion.id}`,
            data,
            { headers: { Authorization: `Bearer ${token}` } }
          )
          alert('活动已更新')
        } else {
          await this.axios.post(
            `/admin/promotions`,
            data,
            { headers: { Authorization: `Bearer ${token}` } }
          )
          alert('活动已创建')
        }
        this.closeModal()
        this.fetchPromotions()
      } catch (err) {
        alert('保存失败: ' + (err.response?.data?.message || err.message))
      }
    },
    async deletePromotion (id) {
      if (!confirm('确定要删除这个活动吗？')) return
      try {
        const token = localStorage.getItem('token')
        await this.axios.delete(
          `/admin/promotions/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        )
        alert('活动已删除')
        this.fetchPromotions()
      } catch (err) {
        alert('删除失败')
      }
    },
    closeModal () {
      this.showAddModal = false
      this.editingPromotion = null
      this.productSearch = ''
      this.showPreview = false
      this.sectionErrors = []
      this.promoForm = {
        name: '',
        banner_image: '',
        start_date: '',
        end_date: '',
        status: 'active',
        gift_rule: '',
        gift_sections: [{ buy_qty: 5, gift_qty: 1 }],
        gift_product_id: '',
        gift_id: '',
        productIds: []
      }
    },
    giftRuleText (promo) {
      if (!promo.gift_rule) return ''

      // 优先使用多档规则
      const sections = promo.gift_sections
      if (sections && Array.isArray(sections) && sections.length > 0) {
        if (sections.length === 1) {
          const s = sections[0]
          return this.formatSingleRule(promo.gift_rule, s.buy_qty, s.gift_qty)
        }
        // 多档显示范围
        const first = sections[0]
        const last = sections[sections.length - 1]
        return `${this.getRuleTypeLabel(promo.gift_rule)} 满${first.buy_qty}赠${first.gift_qty} 至 满${last.buy_qty}赠${last.gift_qty}`
      }

      // 兼容旧格式
      return this.formatSingleRule(promo.gift_rule, promo.buy_quantity, promo.gift_quantity)
    },
    formatSingleRule (ruleType, buyQty, giftQty) {
      const ruleMap = {
        same: `买${buyQty}送${giftQty}同款`,
        sku: `买${buyQty}送${giftQty}其他商品`,
        gift: `买${buyQty}送${giftQty}赠品`
      }
      return ruleMap[ruleType] || ruleType
    },
    getRuleTypeLabel (ruleType) {
      const labelMap = {
        same: '同款赠送',
        sku: '送其他商品',
        gift: '送赠品'
      }
      return labelMap[ruleType] || ruleType
    },
    formatDate (date) {
      if (!date) return '-'
      return new Date(date).toLocaleDateString('zh-CN')
    }
  }
}
